import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useUserContext } from '../context/UserContext';
import { useContractorsContext } from '../context/ContractorsContext';
import { useEffect } from 'react';
import { useRolesContext } from '../context/RolesContext';

const ModalCreatetContractor = ({ onClose, contractor }) => {
  const { id, roleId } = useUserContext();
  const { roles} = useRolesContext();
  const [roleType, setRoleType] = useState(null)
  const { addContractors, editContractors, deleteContractor } = useContractorsContext();
  const [name, setName] = useState(contractor?contractor.name:'');
  const [address, setAddress] = useState(contractor?contractor.address:'');
  const [inn, setInn] = useState(contractor?contractor.inn:'');
  const [kpp, setKpp] = useState(contractor?contractor.kpp:'');
  const [contact, setContact] = useState(contractor?contractor.contact:'');
  const [phone, setPhone] = useState(contractor?contractor.phone:'');

useEffect(()=>{
    if (roles){
      let idx = roles.findIndex((r)=>{return r._id===roleId});
      if (idx !== -1){
        setRoleType(roles[idx].type)
      }
    }
  }, [roles])
  // Обработчик сохранения комментария
  const handleSave = () => {
    if (contractor) {
        editContractors(({name, address, inn, kpp, contact, phone, madeBy: id, editTime: new Date()*1}), contractor._id)
    } else {
        addContractors({name, address, inn, kpp, contact, phone, madeBy: id, dateTime: new Date()*1})
    }
      onClose();
  };

  const handleDelete = () => {
    deleteContractor(contractor._id);
    onClose();
  }

  // Обработчик закрытия окна
  const handleClose = () => {
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="task-modal admin-modal contractor-modal">
        <header className="task-modal__header">
          <h2 className="task-modal__title">
            {!contractor ? 'Создание контрагента' : 'Просмотр и редактирование контрагента'}
          </h2>
          <button className="task-modal__close" onClick={handleClose}>×</button>
        </header>
        <div className="task-modal__body">
          <div className="admin-modal__grid contractor-modal__grid">
            <div className="admin-modal__field admin-modal__field--full">
              <label className="admin-modal__label" htmlFor="name">Наименование</label>
              <input
                className="admin-modal__input"
                id="name"
                required
                value={name}
                onChange={event => setName(event.target.value)}
              />
            </div>

            <div className="admin-modal__field admin-modal__field--full">
              <label className="admin-modal__label" htmlFor="address">Юридический адрес</label>
              <input
                className="admin-modal__input"
                id="address"
                required
                value={address}
                onChange={event => setAddress(event.target.value)}
              />
            </div>

            <div className="admin-modal__field">
              <label className="admin-modal__label" htmlFor="inn">ИНН</label>
              <input
                className="admin-modal__input"
                id="inn"
                required
                value={inn}
                onChange={event => { setInn(event.target.value); }}
              />
            </div>

            <div className="admin-modal__field">
              <label className="admin-modal__label" htmlFor="kpp">КПП</label>
              <input
                className="admin-modal__input"
                id="kpp"
                required
                value={kpp}
                onChange={event => setKpp(event.target.value)}
              />
            </div>

            <div className="admin-modal__field">
              <label className="admin-modal__label" htmlFor="contact">Контактное лицо</label>
              <input
                className="admin-modal__input"
                id="contact"
                required
                value={contact}
                onChange={event => setContact(event.target.value)}
              />
            </div>

            <div className="admin-modal__field">
              <label className="admin-modal__label" htmlFor="phone">Телефон</label>
              <input
                className="admin-modal__input"
                id="phone"
                required
                value={phone}
                onChange={event => setPhone(event.target.value)}
              />
            </div>
          </div>
        </div>

        <footer className="task-modal__footer">
          <button className="task-modal__btn task-modal__btn--ghost" onClick={handleClose}>Отмена</button>
          <button className="task-modal__btn task-modal__btn--primary" onClick={handleSave}>Сохранить</button>
          {(roleType === "firstAdmin" || roleType === "admin") && contractor && (
            <button className="task-modal__btn task-modal__btn--danger" onClick={handleDelete}>Удалить</button>
          )}
        </footer>
      </div>
    </div>
  );
};

// Пропсы, обязательные для корректной работы
ModalCreatetContractor.propTypes = {
  contractor: PropTypes.object,
  onClose: PropTypes.func.isRequired,
};

export default ModalCreatetContractor;